import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Cliente/ComboRutasNoDireccionCliente`, method: 'POST', body: list, token: token})
}